export const CANDIDATE_FORM = 'CANDIDATE_FORM';
